import {AntragsdatenDto} from '@wba/models/dto/antragsdaten-dto';
import {Observable, Subject} from 'rxjs';
import {AntragsdatenSchluessel} from "@wba/models/enums/antragsdaten-schluessel.enum";


export abstract class AntragsdatenService {
  abstract letzteAenderungAm$: Subject<string>;

  abstract getDraft(antragId: string, schluessel: AntragsdatenSchluessel, antragsdatenId?: string): Observable<AntragsdatenDto>;

  abstract getDraftJsondaten<T>(antragId: string, schluessel: AntragsdatenSchluessel, antragsdatenId?: string): Observable<T>;

  abstract patchDraftJsondatenCleanup<T>(antragId: string, schluessel: AntragsdatenSchluessel): Observable<T>;

  abstract getDrafts(antragId: string, withJsondaten?: boolean, schluessel?: string, excludeSchluessel?: AntragsdatenSchluessel): Observable<AntragsdatenDto[]>;

  abstract getAllDraftSchluessel(antragId: string): Observable<string[]>;

  abstract updateDraft(antragsdatenDto: AntragsdatenDto, antragId: string): Observable<AntragsdatenDto>;

  abstract createDraft(antragsdatenDto: AntragsdatenDto, antragId: string): Observable<AntragsdatenDto>;

  abstract deleteDraft(antragId: string, schluessel: AntragsdatenSchluessel, antragsdatenId?: string): Observable<string>;
}
